import Vue from 'vue'
import "./el-style.scss"
import {
    Button,
    ButtonGroup,
    Form,
    Input,
    Select,
    Switch,
    Radio,
    RadioButton,
    CheckboxGroup,
    Checkbox,
    CheckboxButton,
    FormItem,
    Col,
    Row,
    Option,
    OptionGroup,
    DatePicker,
    RadioGroup,
    TimePicker,
    MenuItem,
    Submenu,
    Dropdown,
    Menu,
    DropdownMenu,
    DropdownItem,
    Message,
    Notification,
    MessageBox,
    Breadcrumb,
    BreadcrumbItem,
    Cascader,
    Table,
    TableColumn,
    Dialog,
    Pagination,
    Popover,
    Upload,
    Avatar,
    InputNumber,
    Timeline,
    TimelineItem,
    Card,
    Link,
    Tooltip,
    Tag,
    Tabs, TabPane,
    Steps, Step,
    Loading,
    Badge,
    Alert,
    Tree,
    Drawer,
    Divider,
    Autocomplete,
    Collapse,
    CollapseItem,
    Progress
} from 'element-ui'

Vue.use(Tag)
Vue.use(Popover)
Vue.use(Button)
Vue.use(ButtonGroup);
Vue.use(Form)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Select)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(CheckboxGroup)
Vue.use(CheckboxButton)
Vue.use(Checkbox)
Vue.use(FormItem)
Vue.use(Col)
Vue.use(Row)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(Menu)
Vue.use(DropdownItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Cascader)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dialog)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Avatar)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Card)
Vue.use(Link)
Vue.use(Tooltip)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Loading);
Vue.use(Badge);
Vue.use(Alert);
Vue.use(Tree);
Vue.use(Drawer);
Vue.use(Divider);
Vue.use(Autocomplete);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Progress);


Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
Vue.prototype.$msgbox = MessageBox







